const SECTOR_LABEL_MAP: Record<string, string> = {
  'accounting':      'Accounting Practices',
  'legal':           'Law Practices',
  'conveyancing':    'Conveyancers',
  'real-estate':     'Real Estate Agents & Agencies',
  'precious-metals': 'Bullion Dealers',
  'bullion_dealer':  'Bullion Dealers',
  'tsu':             'Trust & Company Service Providers',
  'other':           'Other',
};

export function formatSectorLabel(sector: string | undefined): string {
  if (!sector) return '';
  return SECTOR_LABEL_MAP[sector.toLowerCase()] ?? sector;
}
